import React, { PureComponent, Fragment } from 'react'
import StayMenuAppBar from '../StayMenuAppBar';
import "./mainContainer.css"
import Sidebar from '../Sidebar';
import SimpleSnackbar from '../SimpleSnackbar';

class MainContainer extends PureComponent {
    componentDidMount() {
        setTimeout(() => {
            this.scroll();
        }, 100);
    }

    scroll = () => {
        const selectedDiv = document.querySelector('.stm-sidebar-selected');
        if (selectedDiv) {
            selectedDiv.scrollIntoView({ behavior: 'instant', inline: 'start' });
        }
    }

    render() {
        const { children, title, menukey } = this.props;
        return (
            <Fragment>
                <StayMenuAppBar title={title} />
                <Sidebar menukey={menukey} />
                <div className="main-container">
                    <div className="child-container">
                        {children}
                    </div>
                </div>
                <SimpleSnackbar />
            </Fragment>
        )
    }
}

export default MainContainer;